import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[appInfiniteScrollSentinel]',
  standalone: true,
})
export class InfiniteScrollSentinelDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input() public disabled = false;
  @Input() public rootMargin = '300px';
  @Output() public readonly reached = new EventEmitter<void>();

  private observer?: IntersectionObserver;
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private isViewInitialized = false;

  public ngAfterViewInit(): void {
    this.isViewInitialized = true;
    this.setupObserver();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (!this.isViewInitialized) {
      return;
    }

    if (!('disabled' in changes) && !('rootMargin' in changes)) {
      return;
    }

    this.setupObserver();
  }

  public ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private setupObserver(): void {
    this.observer?.disconnect();
    this.observer = undefined;

    if (this.disabled || typeof IntersectionObserver === 'undefined') {
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        const isIntersecting = entries.some((entry) => entry.isIntersecting);
        if (isIntersecting && !this.disabled) {
          this.reached.emit();
        }
      },
      { root: null, rootMargin: this.rootMargin, threshold: 0.01 },
    );

    this.observer.observe(this.elementRef.nativeElement);
  }
}
